import { FlyoutModal, InfoButton } from "@naf/teamscheme";
import { type ReactNode, useState } from "react";

export default function InfoButtonModal({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <InfoButton
        type="button"
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(true);
        }}
        open={isOpen}
      />
      <FlyoutModal isOpen={isOpen} onClose={() => setIsOpen(false)}>
        {children}
      </FlyoutModal>
    </>
  );
}
